import React, { useState, useContext, useMemo } from 'react';
var DEFINE_PERMISSIONS = "@@RRP:DEFINE_PERMISSIONS";
var RESET_PERMISSIONS = "@@RRP:RESET_PERMISSIONS";
var definePermission = function definePermission(payload) {
  return {
    type: DEFINE_PERMISSIONS,
    payload: payload
  };
};
var resetPermission = function resetPermission() {
  return {
    type: RESET_PERMISSIONS,
    payload: {}
  };
};
var initialContext = {};
var PermissionContext = React.createContext(initialContext);
var PermissionProvider = function PermissionProvider(props) {
  var store = props.store,
    children = props.children,
    _props$reducerKey = props.reducerKey,
    reducerKey = _props$reducerKey === void 0 ? "permissionsReducer" : _props$reducerKey;
  if (!store) {
    return null;
  }
  var dispatch = store.dispatch,
    getState = store.getState,
    subscribe = store.subscribe;
  var state = getState();
  var permissionsSelector = function permissionsSelector(state) {
    return state[reducerKey] && state[reducerKey].permissions;
  };
  var isLoadedSelector = function isLoadedSelector(state) {
    return state[reducerKey] && state[reducerKey].isLoaded;
  };
  var _useState = useState(permissionsSelector(state)),
    permissions = _useState[0],
    setPermissions = _useState[1];
  var _useState2 = useState(isLoadedSelector(state)),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  subscribe(function () {
    var newState = getState();
    var newPermissions = permissionsSelector(newState);
    var newIsLoaded = isLoadedSelector(newState);
    if (JSON.stringify(newPermissions) !== JSON.stringify(permissions)) {
      setPermissions(newPermissions);
    }
    if (newIsLoaded !== isLoaded) {
      setIsLoaded(newIsLoaded);
    }
  });
  var hasPermission = function hasPermission(allowedPermissions, orAllowedPermissions) {
    if (permissions) {
      var checkPermission = true;
      if (typeof allowedPermissions === "string") {
        return permissions.indexOf(allowedPermissions) !== -1;
      }
      allowedPermissions.forEach(function (ap) {
        if (permissions.indexOf(ap) === -1) {
          checkPermission = false;
        }
      });
      if (typeof orAllowedPermissions === "string" || typeof orAllowedPermissions === "object") {
        var orCheckPermission = true;
        if (typeof orAllowedPermissions === "string") {
          return permissions.indexOf(orAllowedPermissions) !== -1;
        }
        orAllowedPermissions.forEach(function (ap) {
          if (permissions.indexOf(ap) === -1) {
            orCheckPermission = false;
          }
        });
        return checkPermission || orCheckPermission;
      }
      return checkPermission;
    }
    return false;
  };
  var definePermission$1 = function definePermission$1(definePermissions) {
    return dispatch(definePermission(definePermissions));
  };
  return React.createElement(PermissionContext.Provider, {
    value: {
      permissions: permissions,
      hasPermission: hasPermission,
      definePermission: definePermission$1,
      isLoaded: !!isLoaded
    }
  }, children);
};
var initialState = {
  isLoaded: false,
  permissions: []
};
var getInitialState = function getInitialState() {
  return JSON.parse(JSON.stringify(initialState));
};
var permissionsReducer = function permissionsReducer(state, action) {
  if (state === void 0) {
    state = getInitialState();
  }
  switch (action.type) {
    case DEFINE_PERMISSIONS:
      return Object.assign({}, state, {
        isLoaded: true,
        permissions: action.payload
      });
    case RESET_PERMISSIONS:
      return getInitialState();
    default:
      return state;
  }
};
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Show = function Show(_ref) {
  var _ref$when = _ref.when,
    when = _ref$when === void 0 ? "" : _ref$when,
    orWhere = _ref.orWhere,
    fallback = _ref.fallback,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, ["when", "orWhere", "fallback", "children"]);
  var _useContext = useContext(PermissionContext),
    hasPermission = _useContext.hasPermission;
  var show = hasPermission(when, orWhere);
  if (show) {
    return React.Children.map(children, function (child) {
      return React.cloneElement(child, rest);
    });
  }
  return fallback || null;
};
var useAccess = function useAccess() {
  var _useContext = useContext(PermissionContext),
    checkPermission = _useContext.hasPermission,
    definePermission = _useContext.definePermission,
    isLoaded = _useContext.isLoaded;
  var hasPermission = function hasPermission(permissions, orPermissions) {
    return useMemo(function () {
      return checkPermission(permissions, orPermissions);
    }, [permissions, orPermissions]);
  };
  return {
    isLoaded: isLoaded,
    hasPermission: hasPermission,
    definePermission: definePermission
  };
};
export { PermissionContext, PermissionProvider, Show, definePermission, getInitialState, permissionsReducer, resetPermission, useAccess };